import { DataTypeColumn } from '../../commonColumnHelpers'

export const CHAIN_CRM_REPORT_COLUMNS = {
  campaigns: {
    header: 'Campaigns',
    group: 'Company Attributes',
    tooltipName: 'crm_campaigns',
  },
  sales_stages: {
    header: 'Sales Stages',
    group: 'Company Attributes',
    tooltipName: 'crm_sales_stages',
  },
  account_owners: {
    header: 'Account Owners',
    group: 'Company Attributes',
    tooltipName: 'crm_account_owners',
  },
  taglist: {
    header: 'Tags',
    group: 'Company Attributes',
    tooltipName: 'crm_tags',
  },
  contact_tags: {
    header: 'Contact Labels',
    group: 'Company Attributes',
    tooltipName: 'crm_contact_tags',
  },
  contact_count: {
    header: 'Contacts',
    group: 'Company Attributes',
    tooltipName: 'crm_contact_count',
  },
  note_count: {
    header: 'Notes',
    group: 'Company Attributes',
    tooltipName: 'crm_note_count',
  },
  deal_count: {
    header: 'Deals',
    group: 'Company Attributes',
    tooltipName: 'crm_deals_count',
  },
  doors_cnt: {
    header: 'Doors',
    group: 'Company Attributes',
    tooltipName: 'crm_doors_count',
  },
  distributors: {
    header: 'Known Distributors',
    group: 'Company Attributes',
    tooltipName: 'crm_distributors',
  },
  gpos: {
    header: 'Known GPOs',
    group: 'Company Attributes',
    tooltipName: 'crm_gpos',
  },
  campaign_attributed_deal_count: {
    header: 'Attributed Deals',
    group: 'Company Attributes',
    tooltipName: 'crm_campaign_attributed_deal_count',
  },
} satisfies Partial<Record<string, DataTypeColumn>>
